export const authRoles = {
  sa: ["SA"],
  ab: ["AB"],
  all: ["SA", "AB", "PM", "KS"],
  pm: ["PM", "AB", "SA"],
  ks: ["KS", "AB", "SA"],
  absa: ["AB", "SA", "KS"],
};
